import { render, staticRenderFns } from "./preRemind.vue?vue&type=template&id=55b5c902&scoped=true&"
import script from "./preRemind.vue?vue&type=script&lang=ts&"
export * from "./preRemind.vue?vue&type=script&lang=ts&"
import style0 from "./preRemind.vue?vue&type=style&index=0&id=55b5c902&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b5c902",
  null
  
)

export default component.exports